interface PopupAction {
    label: string;
    run?: () => void;
}

interface ErrorPopup {
    title: string;
    message: string;
    actions: PopupAction[];
    closeTab?: boolean;
}

const dialog = document.getElementById('error-popup') as HTMLDialogElement;
const title = document.getElementById('error-title')!;
const message = document.getElementById('error-message')!;
const actions = document.getElementById('error-actions')!;
const closeTabMessage = document.getElementById('error-close-tab-message')!;

// Keep editor shortcuts from changing the document while the dialog has focus.
dialog.addEventListener('keypress', event => event.stopPropagation());

export function closeErrorPopup() {
    if (dialog.open) dialog.close();
}

export function requestCloseTab(fallback: HTMLElement) {
    window.close();
    window.setTimeout(() => {
        if (!window.closed) fallback.classList.remove('hidden');
    }, 500);
}

export function showErrorPopup(options: ErrorPopup) {
    title.textContent = options.title;
    message.textContent = options.message;
    closeTabMessage.classList.add('hidden');
    actions.replaceChildren();
    for (const action of options.actions) {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = action.label;
        button.addEventListener('click', () => {
            dialog.close();
            action.run?.();
        });
        actions.appendChild(button);
    }
    if (options.closeTab) {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = 'Close tab';
        button.addEventListener('click', () => requestCloseTab(closeTabMessage));
        actions.appendChild(button);
    }
    if (!dialog.open) dialog.showModal();
    actions.querySelector('button')?.focus();
}
